module.exports = new __parcel__URL__("jsm-service-request.b423594a.svg").toString();